module.exports = __webpack_public_path__ + "static/media/logo4.65cc316a.svg";